import type { DrawerProps } from '@mui/material';

export const preventBackdropDrawerClose = (
  onClose?: () => void
): DrawerProps['onClose'] => {
  return (_event, reason) => {
    if (reason === 'backdropClick') {
      return;
    }

    onClose?.();
  };
};
